export const dataTestIds = {
	// Chat button
	chatbotButtonOpen: 'mangoAssistant.button.open',
	// About AI message
	aboutAIMessage: 'mangoAssistant.content.infoIA',
	// Fashion Assistant Product
	fashionAssistantProduct: 'chatbot.fa.product',
	// Confirm close bottom sheet
	chatbotSheetConfirmClose: 'mangoAssistant.confirmClose',
	// Confirm close dialog
	chatbotDialogConfirmClose: 'mangoAssistant.confirmClose',
	// Confirm close title
	chatbotConfirmCloseTitle: 'mangoAssistant.confirmClose.title',
	// Confirm close subtitle
	chatbotConfirmCloseSubtitle: 'mangoAssistant.confirmClose.subTitle',
	// Confirm close button
	chatbotConfirmCloseButton: 'mangoAssistant.confirmClose.leaveButton',
	// Cancel close button
	chatbotCancelCloseButton: 'mangoAssistant.confirmClose.cancelButton',
	// Dialog container
	chatbotContainer: 'mangoAssistant.modal.container',
	// Dialog header
	chatbotHeader: 'mangoAssistant.header',
	// Dialog header title
	chatbotHeaderTitle: 'mangoAssistant.header.title',
	// Minimize button
	chatbotMinimizeButton: 'mangoAssistant.header.button.minimized',
	// Close button
	chatbotCloseButton: 'mangoAssistant.header.button.close',
	// Dialog content
	chatbotDialogContent: 'mangoAssistant.content',
	// Ice breakers container
	iceBreakersContainer: 'mangoAssistant.icebrakersContent',
	// Ice breaker button
	iceBreakerButton: 'mangoAssistang.icebrakersContent.icebrakerButton',
	// Dialog footer
	chatbotDialogFooter: 'mangoAssistant.footer',
	// Chatbot Input
	chatbotTextarea: 'mangoAssistant.footer.inputBox',
	// Chatbot submit button
	chatbotSubmitButton: 'mangoAssistant.footer.sendButton',
	// Legal policies
	chatbotLegalPolicies: 'mangoAssistant.footer.privacyPolicy',
	// Greetings message container
	chatbotGreetingsMessageContainer: 'mangoAssistant.content.greeting',
	// Avatar greetings message
	chatbotGreetingsAvatarMessage: 'mangoAssistant.content.greetingAvatar',
	// Greetings message
	chatbotGreetingsMessage: 'mangoAssistant.content.greetingMessage',
	// Error message
	chatbotErrorMessage: 'mangoAssistant.errorMessage',
	// Chatbot messages container
	chatbotMessagesContainer: 'mangoAssistant.content.messagesContainer',
}
